/** Phase buckets for multi-select filters (emerging + ongoing trial UIs). */
export type EmergingPhaseBucket = '1' | '2' | '3';

/** Map a trial phase string to phase buckets (e.g. Phase 1/2 → 1 and 2). */
export function parseEmergingPhaseBuckets(phaseRaw: string | null | undefined): Set<EmergingPhaseBucket> {
  const tags = new Set<EmergingPhaseBucket>();
  if (phaseRaw == null) return tags;
  const s = String(phaseRaw).toLowerCase().replace(/\s+/g, ' ').trim();
  if (!s) return tags;

  const mark = (b: EmergingPhaseBucket) => tags.add(b);

  if (/\bphase\s*1(?:\b|[a-z]\b)|\bph\.?\s*1(?:\b|[a-z]\b)|\bphase\s+i\b(?![a-z])/.test(s)) mark('1');
  if (/\bphase\s*2(?:\b|[a-z]\b)|\bph\.?\s*2(?:\b|[a-z]\b)|\bphase\s+ii\b(?![a-z])/.test(s)) mark('2');
  if (/\bphase\s*3(?:\b|[a-z]\b)|\bph\.?\s*3(?:\b|[a-z]\b)|\bphase\s+iii\b/.test(s)) mark('3');

  if (/(?:^|[\s,/()+])1(?:[\s,/()+a-z]|\s*$)/.test(s)) mark('1');
  if (/(?:^|[\s,/()+])2(?:[\s,/()+a-z]|\s*$)/.test(s)) mark('2');
  if (/(?:^|[\s,/()+])3(?:[\s,/()+a-z]|\s*$)/.test(s)) mark('3');

  return tags;
}

/** When selected is empty, show all; else trial must match at least one bucket. Unknown/empty phase hidden when filtering. */
export function trialMatchesPhaseBuckets(
  phaseRaw: string | null | undefined,
  selected: EmergingPhaseBucket[],
): boolean {
  if (selected.length === 0) return true;
  const tags = parseEmergingPhaseBuckets(phaseRaw);
  if (tags.size === 0) return false;
  return selected.some((p) => tags.has(p));
}
